import React, {useState} from "react";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useCustomerAccount } from "../../AccountProvider";
import { getEmailErrors } from "../../../../utils/validators";
import { getVerifiedPhone } from "../../../../utils";
import { isNativeApp } from "../../../../utils"
import {Button, ButtonGroup, TextField} from "@one-thd/sui-atomic-components";



const EmailForm = (props) => {

  const { onCancel, initiateEmailChange, initialOtpChoiceFlow } = props;
  const { account } = useCustomerAccount();

  const primaryPhoneNumber = getVerifiedPhone(account);
  const otpChannel = primaryPhoneNumber ? "sms" : "email";

  const emailFieldAutomationId = "login-information-email-form--edit-password-field";
  const cancelButtonAutomationId = "login-information-email-form--button-cancel";
  const submitButtonAutomationId = "login-information-email-form--button-submit";

  const [ errorState, setErrorState ] = useState({
    errors: [],
    email: [],
    valid: true,
  });

  const handleOnFocusOut = () => {
    if(!isEmpty(errorState.email)){
      setErrorState({  ...errorState, valid: false })
    }else{
      setErrorState({ ...errorState, valid: true })
    }
  }

  return (
    <Formik
    initialValues={{ email: ""}}
    validate={( values ) => {
      const { email = [] } = getEmailErrors(values.email, props.currentEmail);
      if (values.email === props.currentEmail) {
        setErrorState({ ...errorState, email, valid: false });
      }
      else {
        setErrorState({ ...errorState, email, valid: true });
      }
    }}
    onSubmit={( values ) => {

      const setErrorMessage = (errorList) => {
        setErrorState({ ...errorState, errors: errorList, valid: false})
      };
      if (values.email !== props.currentEmail) {
        setErrorState({ ...errorState, errors: [], valid: true })
        if (account.primaryPhoneAvailable) {
          initialOtpChoiceFlow(props.currentEmail, values.email, account.profile.existingPhoneNumber, otpChannel, setErrorMessage, primaryPhoneNumber);
        } else {
          initiateEmailChange(values.email, otpChannel, setErrorMessage);
        }
      }
    }}
    
    >
    {({values, handleSubmit, handleChange}) => (
        
        <div className="security-info-row" id="email-edit-section">
        <form className="col__12-12 u--paddingNone-left u--paddingNone-right" onSubmit={handleSubmit}>
          <div className="security-info-column">
            <div className="col__12-12 no-padding-sides">
              <TextField 
                autoFocus={ !isNativeApp() } // eslint-disable-line
                id="email"
                name="email" 
                type="email" 
                label="Email" 
                onChange={handleChange}
                onBlur={handleOnFocusOut}
                value={values.email}
                status={!errorState.valid ? "error" : null}
                InputProps={{"data-automation-id": emailFieldAutomationId}}
                statusMessage={!errorState.valid ? (errorState.email[0] || errorState.errors[0] ) : ""}
                />
            </div>
            <ButtonGroup responsive>
              <Button variant="primary" type="submit" disabled={!isEmpty(errorState.email) || !values.email} data-automation-id={submitButtonAutomationId}>
                Save Changes
              </Button>
              <Button onClick={onCancel} data-automation-id={cancelButtonAutomationId}>
                Cancel
              </Button>
            </ButtonGroup>
          </div>
        </form>
    </div>
)}
    </Formik>
  );
};


export default EmailForm;